import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RestTimerDemoState } from 'pages/test-ui-components/cs-test-rest-timer-demo';

// The Rest Timer card's body on the Test UI Components page (#6020): the rest-timer pill running and
// over, each driven by its own stand-in timer (cs-test-rest-timer-demo).
@Component({
  selector: 'cs-test-rest-timer-card',
  host: { class: 'showcase-card-body' },
  template: `
    <div class="showcase-grid">
      <div class="showcase-row" data-showcase-id="cs-rest-timer-pill">
        <cs-label>cs-rest-timer-pill running (tap it for cs-rest-timer-expanded)</cs-label>
        <cs-test-rest-timer-demo [state]="RestTimerDemoState.Running"></cs-test-rest-timer-demo>
      </div>

      <div class="showcase-row" data-showcase-id="cs-rest-timer-pill-over">
        <cs-label>cs-rest-timer-pill when the rest is over</cs-label>
        <cs-test-rest-timer-demo [state]="RestTimerDemoState.Expired"></cs-test-rest-timer-demo>
      </div>

      <cs-note>These use a stand-in timer that belongs to this page only: no wake lock and no notification.</cs-note>
    </div>
  `,
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CsTestRestTimerCardComponent {
  readonly RestTimerDemoState = RestTimerDemoState;
}
